import { useLocation, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { Flag, isAuthenticated } = useSelector((state) => state.auth);
  
  if (isAuthenticated && location.pathname !== "/Home/verify" && Flag === false) {
    return <Navigate to="/Home/verify" replace />;
  }

  if (!isAuthenticated && !location.pathname.startsWith("/Home")) {
    return <Navigate to="/Home" replace />;
  }

  return children;
}

export default ProtectedRoute;